export type AuthNavigator = (url: string) => void;

const navigateInBrowser: AuthNavigator = (url) => {
  window.location.assign(url);
};

export async function startGoogleSignIn(options: {
  navigate?: AuthNavigator;
  returnPath?: string;
} = {}): Promise<void> {
  const navigate = options.navigate ?? navigateInBrowser;
  const returnPath = options.returnPath ?? `${window.location.pathname}${window.location.search}`;
  const response = await fetch("/api/auth/sign-in/social", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
    },
    body: JSON.stringify({
      provider: "google",
      callbackURL: `${window.location.origin}${returnPath.startsWith("/manage") ? returnPath : "/manage"}`,
      disableRedirect: true,
    }),
  });
  const result = await response.json().catch(() => null) as { url?: string; message?: string } | null;
  if (!response.ok || !result?.url) {
    throw new Error(result?.message ?? "Google sign-in could not start.");
  }
  navigate(result.url);
}

export async function signOutCreator(navigate: AuthNavigator = navigateInBrowser): Promise<void> {
  const response = await fetch("/api/auth/sign-out", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
    },
    body: "{}",
  });
  if (!response.ok) throw new Error("Sign-out could not finish.");
  navigate("/manage");
}
